import { randomUUID } from 'node:crypto';

/**
 * Generate a span ID by creating a random UUID v4 and removing the dashes. This is the equivalent
 * of `uuid4().hex` in Python and prefixing it with `span_`.
 * @returns A span ID.
 */
export function generateSpanId(): string {
  return `span_${randomUUID().replace(/-/g, '').slice(0, 24)}`;
}

export function timeIso(): string {
  return new Date().toISOString();
}

export function removePrivateFields(
  obj: Record<string, any>,
): Record<string, any> {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !key.startsWith('_')),
  );
}

export function generateTraceId(): string {
  return `trace_${randomUUID().replace(/-/g, '')}`;
}

/**
 * Generate a group ID by creating a random UUID v4 and removing the dashes. This is the equivalent
 * of `uuid4().hex` in Python and prefixing it with `group_`.
 * @returns A group ID.
 */
export function generateGroupId(): string {
  return `group_${randomUUID().replace(/-/g, '').slice(0, 24)}`;
}
